import React from "react";

/**
 * ReadOut
 * ──────────────────────────────────────────────────────────────
 * A monospace, uppercased, letter-spaced label — used the way
 * NASA mission slates label sections, e.g.
 *
 *   <ReadOut>MISSION // OBJECTIVE</ReadOut>
 *   <ReadOut tone="mission">SYSTEM NOMINAL</ReadOut>
 *   <ReadOut tone="alert">SECURITY LOCKDOWN</ReadOut>
 *
 * Props:
 *   tone: "default" | "accent" | "mission" | "warn" | "alert"
 *   as:   element tag (default span)
 */
export default function ReadOut({ tone = "default", as: Tag = "span", children, className = "", ...rest }) {
  const toneClass =
    tone === "accent"  ? "nasa-readout--accent"  :
    tone === "mission" ? "nasa-readout--mission" :
    tone === "warn"    ? "nasa-readout--warn"    :
    tone === "alert"   ? "nasa-readout--alert"   : "";
  return (
    <Tag
      className={`nasa-readout ${toneClass} ${className}`.trim()}
      data-testid="nasa-readout"
      {...rest}
    >
      {children}
    </Tag>
  );
}
